package com.iregained.site.components.sections.resources.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val BrochureSubmitButtonStyle = CssStyle {
    base {
        Modifier.transition(
            Transition.of("transform", 200.ms),
            Transition.of("box-shadow", 200.ms),
            Transition.of("background-color", 200.ms)
        ).boxShadow(0.px, 4.px, 14.px, 0.px, Colors.Black.copyf(alpha = 0.1f))
    }
    hover {
        Modifier.transform { translateY((-2).px) } // Floats up
            .boxShadow(0.px, 8.px, 20.px, 0.px, Colors.Black.copyf(alpha = 0.15f)) // Deeper shadow
    }
    active {
        Modifier.transform { scale(0.98) } // Tactile click compression
            .boxShadow(0.px, 2.px, 10.px, 0.px, Colors.Black.copyf(alpha = 0.1f))
    }
}